<template>
	<div class="container">
		<div class="content_wrap d_flex">
			<div ref="sidebar" class="content_menu">
				<tnc-sidebar
					@sidebarClick="handleSidebarClick"
					:items="menu_items"
				></tnc-sidebar>
			</div>
			<div class="content_inner">
				<div ref="content" class="content_a">
					<h1 class="content_title tac">{{ $t('terms.title') }}</h1>
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TncSidebar from '@/components/Menu/TncSidebar.vue';

export default {
	name: 'Privacy',
	components: { TncSidebar },
	mounted() {
		window.addEventListener('scroll', this.updateSidebar);
		window.addEventListener('resize', this.updateSidebar);
	},
	beforeUnmount() {
		window.removeEventListener('scroll', this.updateSidebar);
		window.removeEventListener('resize', this.updateSidebar);
	},
	beforeRouteLeave(to, from, next) {
		window.document.documentElement.style.scrollBehavior = '';
		next();
	},

	data() {
		return {
			menu_items: [
				{
					title: 'terms.menu.category1',
					href: 'privacy1',
					children: [
						{
							title: 'terms.menu.title1',
							href: 'privacy1',
						},
						{
							title: 'terms.menu.title2',
							href: 'privacy2',
						},
						{
							title: 'terms.menu.title3',
							href: 'privacy3',
						},
						{
							title: 'terms.menu.title4',
							href: 'privacy4',
						},
						{
							title: 'terms.menu.title5',
							href: 'privacy5',
						},
						{
							title: 'terms.menu.title6',
							href: 'privacy6',
						},
						{
							title: 'terms.menu.title7',
							href: 'privacy7',
						},
						{
							title: 'terms.menu.title8',
							href: 'privacy8',
						},
						{
							title: 'terms.menu.title9',
							href: 'privacy9',
						},
						{
							title: 'terms.menu.title10',
							href: 'privacy10',
						},
						{
							title: 'terms.menu.title11',
							href: 'privacy11',
						},
						{
							title: 'terms.menu.title12',
							href: 'privacy12',
						},
						{
							title: 'URL_가맹점정보의 공동이용에 대하여',
							href: 'privacy13',
						},
					],
				},
				{
					title: this.$t('terms.menu.category2'),
					href: '',
					children: [
						{
							title: '가맹점 가이드라인(미니앱용)',
							href: '',
						},
						{
							title: '가맹점 가이드라인(온라인)',
							href: '',
						},
					],
				},
			],
		};
	},
	methods: {
		// updateSidebar() {
		// 	let doc = document.documentElement;
		// 	let top = (doc && doc.scrollTop) || document.body.scrollTop;
		// 	const allHeaders = this.$refs.content.querySelectorAll(
		// 		'h1, h2, h3, h4, h5, h6',
		// 	);
		// 	let last;
		// 	for (let i = 0; i < allHeaders.length; i++) {
		// 		let link = allHeaders[i];
		// 		if (link.offsetTop > top) {
		// 			if (!last) last = link;
		// 			break;
		// 		} else {
		// 			last = link;
		// 		}
		// 	}
		// 	if (last && last.id.length) this.setActive(last.id, false);
		// },
		// setActive(id, shouldScrollIntoView) {
		// 	// console.log('aaa');
		// 	const sidebar = this.$refs.sidebar;
		// 	let previousActive = sidebar.querySelector('a.active');
		// 	let currentActive =
		// 		typeof id === 'string'
		// 			? sidebar.querySelector('a[name=' + id + ']')
		// 			: id;
		// 	if (currentActive !== previousActive) {
		// 		if (previousActive) previousActive.classList.remove('active');
		// 		currentActive.classList.add('active');
		// 		if (shouldScrollIntoView) {
		// 			let currentPageOffset = 0;
		// 			let currentActiveOffset =
		// 				currentActive.offsetTop + currentActive.parentNode.clientHeight;
		// 			let sidebarHeight = sidebar.clientHeight;
		// 			let currentActiveIsInView =
		// 				currentActive.offsetTop >= sidebar.scrollTop &&
		// 				currentActiveOffset <= sidebar.scrollTop + sidebarHeight;
		// 			let linkNotFurtherThanSidebarHeight =
		// 				currentActiveOffset - currentPageOffset < sidebarHeight;
		// 			let newScrollTop = currentActiveIsInView
		// 				? sidebar.scrollTop
		// 				: linkNotFurtherThanSidebarHeight
		// 				? currentPageOffset
		// 				: currentActiveOffset - sidebarHeight;
		// 			sidebar.scrollTop = newScrollTop;
		// 		}
		// 	}
		// },
		// moveScroll(href) {
		// 	const offsetTop = document.getElementById(href).offsetTop;
		// 	window.scrollTo({ top: offsetTop });
		// },
		handleSidebarClick(href) {
			// window.document.documentElement.style.scrollBehavior = 'smooth';
			// this.moveScroll(href);
			this.$router.push({ name: href });
		},
	},
};
</script>
